import { Sort } from '@angular/material/sort';

export interface ISnListQueryParameters {
  search?: string;
  ordering?: string | Sort;
  page?: number;
  pageSize?: 'all' | number;
  radius?: number;
  group?: string;
  group__isnull?: boolean;
  lpr_hotlist?: string;
  camera_name?: string;
  mode?: string;
  cursor?: string;

  [name: string]: any;
}
